module.exports = __webpack_public_path__ + "assets/trustarc.07438fd3.svg";